import { notifications as notificationsConstants } from '../helpers';

export const PANEL_STYLES = {
  DANGER: { style: 'danger', text: '' },
  DEFAULT: { style: 'default', text: '' },
  PRIMARY: { style: 'primary', text: '' },
  SUCCESS: { style: 'success', text: '' },
  WARNING: { style: 'warning', text: '' }
};

export const getChecked = (model, value) => {
  return (model & value) === value;
};

export const getTogglesValue = (model, value, checked) => {
  const newValue = checked ? +value : -value;
  return model + newValue;
};

/**
 * Checks if the cron input field is valid on the component while
 * taking into consideration other control values
 * @param {*} modelValue - expects to be a formData object from the state
 * of the LocalForm in NotificationsSelectorComponent
 */
export const validateNotificationCron = (modelValue) => {
  // not subscribing to email -> ignore
  if (!getChecked(
    modelValue.ruleTypes,
    notificationsConstants.RULETYPES.EMAIL)) {
    return true;
  }

  // subscribed but empty -> not allowed
  if (modelValue.cron === '') {
    return false;
  }

  // check for full valid expressions, consisting of at least 5 fields
  // we want to validate as users type for consistency -> less than 5 fields
  // is not allowed
  return modelValue.cron.match(
    /^(((\*|\?|\d+)((\/|-){0,1}(\d+))*)\s{1}){4}(((\*|\?|\d+)((\/|-){0,1}(\d+))*)){1}$/g
  );
};


// WEBPACK FOOTER //
// src/helpers/componentHelper.js